module.exports = __webpack_public_path__ + "static/img/ico-barisul.ea5d5a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/bancos/ico-barisul.png
// module id = GDvA
// module chunks = 0